import type {
  ItemsReplacementModel,
  SelectedItemsOutStock,
  SelectedNodeIds,
} from './substitutionFlow.model';
import type { OrderDetailModel } from 'shared/domain';

export const NODE_IDS_INIT: SelectedNodeIds = {
  products: [],
  toppings: [],
};

export const ATTRIBUTE_NAME_OP_ID = 'data-order-product-id';

export const ITEMS_REPLACEMENT_MODEL_INIT: ItemsReplacementModel = {
  products: [],
  toppings: [],
};

export const SELECTED_ITEMS_OUT_STOCK_INIT: SelectedItemsOutStock = {
  products: [],
  toppings: [],
};
